import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '~src/httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '~src/httpClient/serverApi/types/IGetItemsResult';

import { IProjectName } from '../types/IProject';

export interface IGetProjectNamesResult extends IGetItemsResult {
  projects: IProjectName[];
}

export class GetProjectNamesRequest extends Request<IGetItemsParams, IGetProjectNamesResult> {
  constructor(params: IGetItemsParams) {
    super('getProjectNames', params);
  }
}
